import React from 'react';
import { Grid, Button } from 'semantic-ui-react';
import { useSelector, useDispatch } from 'react-redux';

import pluralize from 'utils/pluralize';

// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';
import ErrorAlert from 'components/ErrorAlert';

import { updateQueryString } from 'services/router/actions';
import { requestCompleteSprayEvents } from 'services/sprayEvents/actions';

import { selectSelectedIncompleteSprayEventsUuids } from '../../../SprayEventsVirtualizedTable/selectors';
import { NAMESPACE, COMPLETE_SPRAY_EVENT_MODAL } from '../../constants';

export function CompleteWeedSprayEventConfirmation(): React.ReactElement {
    const uuids = useSelector(selectSelectedIncompleteSprayEventsUuids);
    const dispatch = useDispatch();

    const handleCompleteWeedSprayEvent = (): void => {
        dispatch(requestCompleteSprayEvents(uuids));
    };
    const handleClose = (): void => {
        dispatch(
            updateQueryString({
                [COMPLETE_SPRAY_EVENT_MODAL]: undefined
            })
        );
    };

    return (
        <React.Fragment>
            <p>
                Are you sure you want to complete {uuids.length} weed{' '}
                {pluralize(uuids.length, 'spray', 'sprays')}?
            </p>
            <ErrorAlert namespace={NAMESPACE} />
            <Grid>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Button
                        type="button"
                        onClick={handleClose}
                        fluid
                        basic
                        primary
                    >
                        Cancel
                    </Button>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    <SubmittingButton
                        type="button"
                        namespace={NAMESPACE}
                        fluid
                        primary
                        onClick={handleCompleteWeedSprayEvent}
                    >
                        Complete
                    </SubmittingButton>
                </Grid.Column>
            </Grid>
        </React.Fragment>
    );
}

export default React.memo(CompleteWeedSprayEventConfirmation);
